import echo from "laravel-echo"
global.io = require('socket.io-client');

export function createSocket(store) {
    if (typeof io !== 'undefined') {
        var token = store.getters.getToken;
        if(token){
            var xmlhttp = new XMLHttpRequest();
            xmlhttp.open('GET',store.getters.getApi + 'auth/me', false);
            xmlhttp.setRequestHeader('Authorization', 'Bearer ' + token);
            xmlhttp.send(null);
            xmlhttp.onload = () => {
            };
            if (xmlhttp.status == 200) {
                let res = JSON.parse(xmlhttp.response);
                var client = new echo({
                        broadcaster: 'socket.io',
                        host: store.getters.getSocket,
                        auth: {
                            headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: 'application/json',
                            },
                        },
                    });
                client.private.prefix = (room) => {
                    let uid = res.result.user[0].uid;
                    return client.private(`${room}.${uid}`)
                }
            }
        }
    }
   
    return client
}




// WEBPACK FOOTER //
// ./src/plugins/socket.js